function getSearchParams(name) {
  // URLSearchParams doesn't work with IE11 and React Router(?)
  // if (window && window.URLSearchParams) {
  //   const params = new window.URLSearchParams(window.location.search);
  //   return params.get(name);
  // }
    // eslint-disable-next-line no-useless-escape
    const cleanedName = name.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${cleanedName}(=([^#&]*)|&|#|$)`);
    const results = regex.exec(window.location.href);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export default getSearchParams;
